module.exports = __webpack_public_path__ + "static/media/compass-slash.b266a4aa.svg";